import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import  store from '../../store/'
import { Link } from 'react-router-dom';
import ArrowLeft from '@material-ui/icons/ChevronLeft'
function TabContainer(props) {
    return (
      <Typography component="div" style={{ padding: 8 * 3 }}>
        {props.children}
      </Typography>
    );
  }
  
  TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
  };
  
  const styles = theme => ({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
      marginBottom: '1em',
      padding: theme.spacing.unit,
    },
    navItem: {
      color: theme.palette.primary.dark
    }
  });
  
  class InAppNav extends React.Component {
    state = {
      value: 0,
    };
  
    handleChange = (event, value) => {
      this.setState({ value });
      store.dispatch({ type: 'CHANGE_VIEW', value })

    };

 
 
    render() {
   
      const { classes, links } = this.props
      if(typeof(links)==='undefined')return null
      return (
        <div className={classes.root}>
          {links.map((link, index) =>
          <span
            onClick={this.props.handleOnClick ? ()=>this.props.handleOnClick() : null}
            key={index}
            className={classes.navItem}
          >
            <ArrowLeft
              color='primary'
              style={{verticalAlign: 'bottom'}}

              />
                <Link style={{color: 'inherit'}} to={link.route}>{link.name}</Link>
            </span>
          )}
     
        </div>
      );
    }
  }
  
  InAppNav.propTypes = {
    classes: PropTypes.object.isRequired,
  };



  export default compose(withRouter, withStyles(styles))(InAppNav);
 
  


// WEBPACK FOOTER //
// ./src/Components/InAppNav/InAppNav.js